<template>
  <div class="sorteos-globales-eventos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Sorteo Global">
          <transition name="slide">
            <b-form>
              <b-form-group
                label="Cliente"
                label-for="cliente"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="cliente"
                  :value="cliente"
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Nombre"
                label-for="sorteoGlobal"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="sorteoGlobal"
                  :value="sorteoGlobal"
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>

              <!-- <b-form-group
                v-if="sorteado"
                label="Fecha Sorteo"
                label-for="fechaSorteo"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="fechaSorteo"
                  :value="fechaSorteo | fechaHora"
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group> -->
            </b-form>
          </transition>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Eventos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="eventos" 
              :fields="eventosFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaInicio)="data">
              {{ data.item.fechaInicio | fecha }}
            </template>
            <template v-slot:cell(fechaFin)="data">
              {{ data.item.fechaFin | fecha }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown 
                  v-if="!sorteado"
                  variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="borrarEvento(data.item)">
                  <i class="fa fa-remove"></i>Eliminar Evento</b-dropdown-item>
              </b-dropdown>
            </template>            
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item
              v-if="!sorteado"
              @click.stop="agregarEvento">
            <i class="fa fa-plus"></i>Agregar Evento</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="searchEventoModal" 
        title="Seleccionar Evento"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-evento
        :clienteId="clienteId"
        :tipoEventoId="tipoEventoId"
        @eventoSeleccionado="eventoSeleccionado">
      </app-search-evento>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import SearchEvento from '../eventos/SearchList';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'sorteoGlobalEventos/getField',
  mutationType: 'sorteoGlobalEventos/updateField',
});

export default {
  name: 'SorteosGlobalesEventos',
  components: {
    appSearchEvento: SearchEvento,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      eventosFields: [
        { 
          key: 'id',
          label: 'Nro.Evento'
        },
        { key: 'nombre' },
        { key: 'tipoEvento' },
        { 
          key: 'participantes',
          class: 'text-right' 
        },
        { key: 'fechaInicio'},
        { key: 'fechaFin'},
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 1,
    }
  },
  computed: {
    ...mapFields([
      'clienteId',
      'cliente',
      'sorteoGlobal',
      'fechaSorteo',
      'sorteado',
      'tipoEventoId',
      'eventos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
  },
  created() {
    this.sorteoGlobalId = 0;
    if (this.$route.params){
      if (this.$route.params.sorteoGlobalId){
        this.sorteoGlobalId = this.$route.params.sorteoGlobalId;
      }
    }

    this.showSpinner();
    this.$store.dispatch('sorteoGlobalEventos/inicializar', this.sorteoGlobalId)
      .then(() => this.getItems())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('sorteoGlobalEventos/getEventos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregarEvento () {
      this.$refs.searchEventoModal.show();
    },
    eventoSeleccionado(evento) {
      this.$refs.searchEventoModal.hide();
      if (evento) {
        this.showSpinner();
        this.$store.dispatch('sorteoGlobalEventos/addEvento', evento.id)
          .then(() => this.getItems())
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    borrarEvento(item) {
      this.showModalConfirm('¿Desea eliminar el evento seleccionado del sorteo global?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No');
    },
    borrar(eventoId) {
      this.showSpinner();
      this.$store.dispatch('sorteoGlobalEventos/deleteEvento', eventoId)
        .then(() => this.getItems())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

    consultar (item) {
      // this.$router.push({ name: 'SorteoGlobalDatos', 
      //                     params: { id: item.id }});
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .sorteos-globales-eventos .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .sorteos-globales-eventos .registro table td[aria-colindex="2"] {
    width: Calc(40% - 30px);
  }
  .sorteos-globales-eventos .registro table td[aria-colindex="3"] {
    width: 20%;
  }
  .sorteos-globales-eventos .registro table td[aria-colindex="4"] {
    width: 10%;
  }
  .sorteos-globales-eventos .registro table td[aria-colindex="5"],
  .sorteos-globales-eventos .registro table td[aria-colindex="6"] {
    width: 10%;
  }
  .sorteos-globales-eventos .registro table td[aria-colindex="7"] {
    width: 30px;
  }
</style>
